import React from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";

import { useSelector, useDispatch } from "react-redux";
import { Flex, Text } from "@chakra-ui/react";
import Button from "../../components/FormElements/Button";
import { Box, Button as ChakraUIButton } from "@chakra-ui/react";
import StudentList from "../components/StudentList";
import { unwrapResult } from "@reduxjs/toolkit";
import { Link } from "react-router-dom";
import "./Student.css";
import Spinner from "../../components/FormElements/Spinner";
import { getStudentWeekWise } from "../../features/students/studentSlice";
import { logout, reset } from "../../features/auth/authSlice";
import { AlertDialog } from "../../components/UIElements/AlertDialog";
import { Heading } from "@chakra-ui/react";
import { SHARED_ROUTES } from "../../config/routes";



const RegStudent = (props) => {
  //initialise dispatch
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const params = {
    date: searchParams.get("weekStartingDate"),
    locationID: searchParams.get("locationId"),
    locationName: searchParams.get("name")
  };

  const year = params.date ? new Date(params.date).getFullYear() : null;

  const { student, isLoading, isError } = useSelector(
    (state) => state.student
  );
  const students = student; //TODO: Fix Redux state naming

  useEffect(() => {
    dispatch(getStudentWeekWise({ params }))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          return response.payload.recordset;
        } else {
          throw response.payload;
        }
      })
      .then(unwrapResult)
      .catch((error) => {
        if (
          error.status === 500 ||
          error.status === 401 ||
          error.status === 403
        ) {
          window.alert("Authorisation error: please sign in again.");
          //reset user
          dispatch(logout()).then(() => {
            dispatch(reset());
            navigate("/");
          });
        } else {
          navigate("/"); //refresh page
          window.alert("Error: failed to load students");
        }
      });
  }, []);

  if (isLoading && !isError) return <Spinner />;
  if (isError)
    return <AlertDialog variant="error" message="Error loading students" />;

  return students && students.length === 0 ? (
    <Box>
      <ChakraUIButton as="span" leftIcon={<ArrowBackIcon />} colorScheme="red" variant="link" mt="0.5em" mb="0.7em" onClick={() => navigate(`${SHARED_ROUTES.home}?year=${year}&locationId=${params.locationID}`)}>
        Back
      </ChakraUIButton>
      <Flex direction="column" alignItems="center" mt="5em" mb="5em" fontWeight="semibold">
        <Text>
          No students registered yet for a week starting <strong>{params.date}</strong> for <strong>{props.locationName}</strong>
        </Text>
        <Text>Would you like to register a student?</Text>
        <Link to={`${SHARED_ROUTES.createStudent}?weekStartingDate=${params.date}&locationId=${params.locationID}`} className="student-button">
          <Button as="span" colorScheme="red">
            Add Student
          </Button>
        </Link>
      </Flex>
    </Box>
  ) : (
    <>
      <ChakraUIButton as="span" leftIcon={<ArrowBackIcon />} colorScheme="red" variant="link" mt="0.5em" mb="0.7em" onClick={() => navigate(`${SHARED_ROUTES.home}?year=${year}&locationId=${params.locationID}`)}>
        Back
      </ChakraUIButton>
      <Heading as="h3" size="sm" fontWeight="semibold" mb="1em">
        Students registered for week starting from <strong>{params.date}</strong> for <strong>{props.locationName}</strong>
      </Heading>
      <StudentList students={students} date={params.date} locationID={params.locationID} shouldOmitWeekDetails />
    </>
  );
};

export default RegStudent;
